"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMonitorOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.791 17a1 1 0 00-.94.658l-.363 1A1 1 0 007.427 20h9.146a1 1 0 00.94-1.342l-.365-1a1 1 0 00-.94-.658H14v-3h5a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h5v3H7.791zM6 12V6h12v6H6z' }))); };
exports.default = SvgMonitorOutline;
//# sourceMappingURL=MonitorOutline.js.map